const localeConfig = require('./assets/localization/config.json');

// Translations are read from public/locales/<lng>/translation.json (WHIT-408).
// A language without its own file, and any key a file lacks, falls back to
// English. `default` is Next's placeholder locale that proxy.ts
// redirects away from.
const getFallbackLanguages = () => {
  const fallbacks = { default: ['en'] };
  if (!localeConfig.locales || !process.env.NEXT_PUBLIC_I18N_SUPPORTED_LANGS)
    return fallbacks;

  localeConfig.locales.forEach(loc => {
    if (process.env.NEXT_PUBLIC_I18N_SUPPORTED_LANGS.includes(loc.locale)) {
      fallbacks[loc.locale] = [...new Set([loc.default, 'en'])];
    }
  });
  return fallbacks;
};

// Staging builds the same languages as production, so Hungarian can be
// checked there before release.
/** @type {import('next-i18next/pages').UserConfig} */
const i18n = {
  i18n: {
    defaultLocale: 'default',
    locales: process.env.NEXT_PUBLIC_I18N_SUPPORTED_LANGS
      ? [
          'default',
          ...process.env.NEXT_PUBLIC_I18N_SUPPORTED_LANGS.split(';'),
        ]
      : ['default', 'en'],
  },
  defaultNS: 'translation',
  // Keys are the English text itself ("Loading...", "Accept the
  // privacy policy."), so a dot or colon must not split them.
  keySeparator: false,
  nsSeparator: false,
  fallbackLng: getFallbackLanguages(),
  ns: ['translation'],
  react: {
    bindI18n: 'languageChanged loaded',
    useSuspense: false,
  },
  debug: false,
  serializeConfig: false,
};

module.exports = i18n;
